import { Controller } from "@hotwired/stimulus"
import { createWritingEditor } from "../editor/setup"
import { api } from "../editor/store"

export default class extends Controller {
  static targets = ["seed", "mount"]
  static values = {
    saveUrl: String,
    param: String,
    main: Boolean,
    placeholder: String
  }

  connect() {
    this.mountTarget.replaceChildren()
    this.dirty = false
    this.saving = false

    const { body } = JSON.parse(this.seedTarget.textContent)
    this.view = createWritingEditor({
      parent: this.mountTarget,
      doc: body,
      placeholderText: this.placeholderValue,
      onDocChanged: () => this.docChanged(),
      onSaveRequested: () => this.save()
    })

    if (this.mainValue) {
      this.view.focus()
      this.announceWordCount()
    }
  }

  disconnect() {
    if (this.dirty) this.save()
    this.view?.destroy()
  }

  focus() {
    this.view?.focus()
  }

  docChanged() {
    this.dirty = true
    clearTimeout(this.saveTimer)
    this.saveTimer = setTimeout(() => this.save(), 900)
    if (this.mainValue) this.announceWordCount()
  }

  async save() {
    if (!this.dirty || this.saving) return
    clearTimeout(this.saveTimer)
    this.saving = true
    this.dirty = false
    this.emit("ootline:saving", {})

    try {
      const payload = { [this.paramValue]: { body: this.view.state.doc.toString() } }
      const response = await api(this.saveUrlValue, { method: "PATCH", body: payload })
      this.emit("ootline:saved", { ...response, main: this.mainValue })
    } catch {
      this.dirty = true
      this.emit("ootline:save-failed", {})
    } finally {
      this.saving = false
      if (this.dirty) this.saveTimer = setTimeout(() => this.save(), 2000)
    }
  }

  announceWordCount() {
    const words = this.view.state.doc.toString().match(/[\p{L}\p{N}_'-]+/gu)?.length || 0
    this.emit("ootline:wordcount", { words })
  }

  emit(name, detail) {
    this.element.dispatchEvent(new CustomEvent(name, { bubbles: true, detail }))
  }
}
